import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from 'vue';
import { useActions } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'QueryExecutionResult',
    props: {
        queryId: null,
        showResults: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const currentTab = ref('original');
        const { find: fetchQueryReport } = useActions('query-report', ['find']);
        const loading = ref(false);
        const modifiedRowsCount = ref(0);
        const rows = ref([]);
        const headers = computed(() => {
            const columns = new Set;
            rows.value.forEach((row) => Object.keys(row).forEach(column => columns.add(column)));
            return Array.from(columns).map(column => ({
                text: column,
                align: 'start',
                sortable: false,
                value: column,
                width: 'auto',
            }));
        });
        const page = ref(1);
        const perPage = ref(10);
        async function fetchData() {
            loading.value = true;
            const result = await fetchQueryReport({
                query: {
                    queryId: props.queryId,
                    type: currentTab.value,
                    offset: perPage.value * (page.value - 1),
                    limit: perPage.value
                }
            }).finally(() => loading.value = false);
            rows.value = result.data;
            modifiedRowsCount.value = result.total;
        }
        watch(() => props.showResults, (showResults) => {
            if (showResults) {
                fetchData();
            }
        }, { immediate: true });
        watch([currentTab, perPage, page], () => {
            fetchData();
        });
        return { __sfc: true, props, currentTab, fetchQueryReport, loading, modifiedRowsCount, rows, headers, page, perPage, fetchData };
    }
});
